import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CardLayerTracking from 'components/molecules/CardLayerTracking';
import { actionCreators as trackingAC } from 'store/trackingDescription';

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doRequestDescriptions: trackingAC.doRequestDescriptions,
		},
		dispatch
	);
};

export default connect(null, mapDispatchToProps)(CardLayerTracking as any);
